import { render } from "./SequenceCard.vue?vue&type=template&id=24bd1921&scoped=true"
import script from "./SequenceCard.vue?vue&type=script&lang=js"
export * from "./SequenceCard.vue?vue&type=script&lang=js"

import "./SequenceCard.vue?vue&type=style&index=0&id=24bd1921&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bd1921"]])

export default __exports__